import Image, { StaticImageData } from 'next/image';
import Dana from './images/dana.png';
import Aries from './images/aries.png';
import Kirsten from './images/kirsten.png';
import Dong from './images/dong.png';
import PurpleCircle from './images/purple-circle.png';
import { Description } from '@snapi/luxury';

interface ScientistCardProps {
  img: StaticImageData;
  name: string;
  children?: React.ReactNode;
}

function ScientistCard({ img, name, children }: ScientistCardProps) {
  return (
    <div className="flex flex-col xs:flex-row lg:flex-col lg:w-[420px] gap-5 xl:w-[522px]">
      <div className="w-[160px] xl:w-[200px]">
        <Image src={img} alt="" />
      </div>
      <div>
        <h4 className="mb-2 w-[200px] xl:w-[240px]">{name}</h4>
        <div className="w-[200px] mt-2 flex flex-col gap-2 text-body">
          {children}
        </div>
      </div>
    </div>
  );
}

export function ScienceTeam() {
  return (
    <section id="advisors-section-science" className="relative">
      <div
        className="absolute top-[-40px] left-[-80px] w-[122px] sm:w-[100px] sm:left-[-10px] 
            md:w-[122px] md:top-[-60px] xl:top-[30px] xl:left-[-60px]"
      >
        <Image src={PurpleCircle} />
      </div>
      <div className="container">
        <h2 className="mb-10 max-w-[420px] md:max-w-[556px] lg:max-w-full">
          Hey, it’s your science team!
        </h2>
        <div className="flex flex-col gap-10 lg:flex-row">
          <ScientistCard img={Dong} name="Dong Kong, Ph.D">
            <div className="opacity-70 flex flex-col gap-2">
              <Description> Scientific Co-Founder</Description>
              <Description>Harvard Medical School</Description>
              <Description>Boston Children’s Hospital</Description>
              <Description>Broad Institute</Description>
            </div>
          </ScientistCard>
          <ScientistCard img={Dana} name="Dana Schechner, MS RD CDN CLC">
            <div className="opacity-70 flex flex-col gap-2">
              <Description> Registed Dietitian</Description>
              <Description>Certified Lactation Counselor</Description>
              <Description>New York Presbyterian Hospital</Description>
              <Description>Montefiore Pediatric Program</Description>
            </div>
          </ScientistCard>
          <ScientistCard img={Kirsten} name="Kirsten Grond, Ph.D">
            <div className="opacity-70 flex flex-col gap-2">
              <Description>Lead computational biologist</Description>
              <Description>Postdoctoral Fellow</Description>
              <Description>
                University of Alaska Anchorage, Anchorage
              </Description>
            </div>
          </ScientistCard>
          <ScientistCard img={Aries} name="Aries Chavira, MS">
            <div className="opacity-70 flex flex-col gap-2">
              <Description>Microbiome Scientist</Description>
              <Description>M.S. Microbiology</Description>
              <Description>University of California, San Diego</Description>
            </div>
          </ScientistCard>
        </div>
      </div>
    </section>
  );
}
